module.exports = __webpack_public_path__ + "static/media/emma-roberts.b66898db.jpg";